export const LicenseSuggestionsMockData = {
  projects: ['PONE', 'PTWO'],
  customers: ['ONE', 'TWO'],
};
